import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { CommentsService } from '../../services/comments.service';

@Component({
    selector: 'sci-comment-dialog',
    templateUrl: './comment-dialog.component.html',
    styles: [ `
        .comment-modal-textarea {
            height: 11em;
            width: 100%;
            margin: 20px 0;
            border-left-width: 5px;
            resize: none;
        }
        .palette-color-a {
            border-left-color: #eee;
        }
    ` ]
})
export class CommentDialogComponent implements OnInit {
    plotId: string;
    comments: any[];

    constructor(
        private _commentsService: CommentsService,
        public dialogRef: MatDialogRef<CommentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit() {
        this.plotId = this.data;
        this._commentsService.getPlotComments$( this.plotId ).subscribe( commentMap => {
            this.comments = [];
            const newComments = Array.from( commentMap.entries() );
            this.comments = newComments.map( newComment => {
                return [
                    'palette-color-' + newComment[0],
                    newComment[1]
                ];
            });
        });
    }

    updateComments() {
        const newMap = new Map();
        this.comments.forEach( comment => newMap.set( comment[0].slice(14), comment[1] ) );
        this._commentsService.setPlotComments( this.plotId, newMap );
        this.dialogRef.close();
    }
}
